module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.e41ca33e.png";